import React from 'react';
import { Line } from 'react-chartjs-2';
import { prepareMessageChartData } from './metricsHelpers';

const MessagesTab = ({ currentMetrics, hourlyMetrics }) => {
  return (
    <div className="bg-white rounded-lg shadow p-4">
      <h3 className="text-lg font-semibold text-gray-700 mb-4">Message Processing</h3>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        <div>
          <h4 className="text-sm font-medium text-gray-500 mb-2">Messages Processed</h4>
          <p className="text-xl font-bold text-blue-600">
            {currentMetrics && currentMetrics.messages_processed != null
              ? currentMetrics.messages_processed.toLocaleString()
              : 'N/A'}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-medium text-gray-500 mb-2">Matched Messages</h4>
          <p className="text-xl font-bold text-green-600">
            {currentMetrics && currentMetrics.messages_matched != null
              ? currentMetrics.messages_matched.toLocaleString()
              : 'N/A'}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-medium text-gray-500 mb-2">Match Rate</h4>
          <p className="text-xl font-bold text-indigo-600">
            {currentMetrics && currentMetrics.messages_processed > 0
              ? `${((currentMetrics.messages_matched / currentMetrics.messages_processed) * 100).toFixed(1)}%`
              : '0%'}
          </p>
        </div>

        <div>
          <h4 className="text-sm font-medium text-gray-500 mb-2">Avg. Processing Time</h4>
          <p className="text-xl font-bold text-blue-600">
            {currentMetrics && currentMetrics.avg_processing_time != null
              ? `${currentMetrics.avg_processing_time.toFixed(2)} ms`
              : 'N/A'}
          </p>
        </div>
      </div>

      {hourlyMetrics.length > 0 && (
        <Line
          data={prepareMessageChartData(hourlyMetrics)}
          options={{
            responsive: true,
            scales: {
              y: {
                beginAtZero: true
              }
            }
          }}
        />
      )}
    </div>
  );
};

export default MessagesTab;
